import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { BreadcrumbModule } from 'primeng/breadcrumb';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MenuModule } from 'primeng/menu';
import { PanelMenuModule } from 'primeng/panelmenu';
import { SplitButtonModule } from 'primeng/splitbutton';

import {
  BaseAvatarComponent,
  BaseBreadcrumbComponent,
  BaseButtonComponent,
  BaseDropdownComponent,
  BaseLabelComponent,
  BaseOverlayPanelComponent,
} from '@d-components';

import { FooterComponent } from './footer/footer.component';
import { HeaderAvatarComponent } from './header/header-avatar.component';
import { HeaderLanguageComponent } from './header/header-language.component';
import { HeaderThemeComponent } from './header/header-theme.component';
import { HeaderComponent } from './header/header.component';
import { MasterLayoutComponent } from './layout.component';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { HeaderNotificationComponent } from './header/header-notification.component';
import { TranslateModule } from '@ngx-translate/core';
import { BaseDropdownTreeComponent } from '@d-components/dropdown-tree/dropdown-tree.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@NgModule({
  declarations: [
    MasterLayoutComponent,
    HeaderComponent,
    HeaderAvatarComponent,
    HeaderLanguageComponent,
    HeaderThemeComponent,
    FooterComponent,
    SideMenuComponent,
    HeaderNotificationComponent,
  ],
  imports: [
    CommonModule,
    SplitButtonModule,
    PanelMenuModule,
    BreadcrumbModule,
    InputSwitchModule,
    FormsModule,
    MenuModule,
    BaseAvatarComponent,
    BaseLabelComponent,
    TranslateModule,
    BaseDropdownComponent,
    BaseDropdownTreeComponent,
    BaseButtonComponent,
    BaseOverlayPanelComponent,
    BaseBreadcrumbComponent,
    ProgressSpinnerModule,
  ],
})
export class LayoutModule {}
